import { Button, Icon, Table }  from 'react-bulma-components';
import React, { Fragment } from 'react';
import { faEdit, faEyeSlash } from '@fortawesome/free-solid-svg-icons';
import { gql, useQuery } from '@apollo/client';

import DefaultError from '../components/defaulterror';
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome'
import IsAdmin from '../containers/isadmin';
import { LevelIndicator } from '../components';
import { Link } from "@reach/router"
import { Loader } from '../components';
import PageTitle from '../components/pagetitle';
import { navigate } from '@reach/router';

export const GET_SONGS = gql`
  query GetSongsList($type: String!) {
    songs(type: $type){
      id
      level
      slug
      title
      published
    }
  }
`;

const Songs = () => {
  const { data, loading, error } = useQuery(GET_SONGS,
    {
      variables: {
        type: "song"
      },
      fetchPolicy: "cache-and-network"
    });
  let isAdmin = true;
  if (error)
  { 
    return (
    <Fragment>
        <DefaultError error={error} />
      </Fragment>
    ); 
  }
  if (loading) return <Loader />;
  return(
    <Fragment>
      <PageTitle name="Songs" description="All songs and more ..." />

      <Table striped={true} size="fullwidth">
        <thead>
        <tr><th>Title</th><th style={{width: "50px"}}></th><th style={{width: "120px"}}>Difficulty</th></tr>
        </thead>
        <tbody>
        { 
         data.songs &&
            data.songs.map(song => 
                <tr key={song.slug} >
                  <td>{song.published!=true?<Icon color="danger"><FontAwesomeIcon icon={faEyeSlash} /></Icon>:null}<Link to={`/song/${song.slug}`}>{song.title}</Link></td>
                  <td><IsAdmin>
                  <Button
                    size="small"
                    onClick={() => {
                      navigate(`/song-edit/${song.slug}`)
                    }
                    }>
                    <Icon color="link"><FontAwesomeIcon icon={faEdit} /></Icon>
                  </Button>
                  </IsAdmin>
                  </td>
                  <td><LevelIndicator level={song.level} max={5} color="green"/></td>
                </tr>
                )
        }
        </tbody>
      </Table>
    </Fragment>
  )
}

export default Songs;